import { metricTrendFragment } from './fragments/reports';

export const getOverviewMetricsQuery = `
  query OverviewMetrics(
    $reportFilter: ReportFilterArgs!
  ) {
    result: overviewMetrics(reportFilter: $reportFilter) {
      newLeads {
        ${metricTrendFragment}
      }
      startedReservations {
        ${metricTrendFragment}
      }
      collectedDeposits {
        ${metricTrendFragment}
      }
      startedBuilds {
        ${metricTrendFragment}
      }
      completedBuilds {
        ${metricTrendFragment}
      }
    }
  }
`;

export const getOverviewSecondaryMetricsQuery = `
  query OverviewSecondaryMetrics(
    $reportFilter: ReportFilterArgs!
  ) {
    results: overviewSecondaryMetrics(reportFilter: $reportFilter) {
      avgBuildValue {
        ${metricTrendFragment}
      }
      avgOptionsSelected {
        ${metricTrendFragment}
      }
      medianTimeToComplete {
        ${metricTrendFragment}
      }
      depositAmount {
        ${metricTrendFragment}
      }
      avgTimeToDeposit {
        ${metricTrendFragment}
      }
      outsideSalesHoursReservations {
        ${metricTrendFragment}
      }
    }
  }
`;

export const getEngagementOverTimeQuery = `
  query EngagementOverTime(
    $reportFilter: ReportFilterArgs!
    $interval: String
  ) {
    items: engagementOverTime(reportFilter: $reportFilter, interval: $interval) {
      date
      ownlyVisitorsCount
      returningOwnlyVisitorsCount
      newLeadsCount
    }
  }
`;

export const getTrafficByCommunityAndProjectQuery = `
  query CommunityProjectTraffic(
    $reportFilter: ReportFilterArgs!
  ) {
    results: communityProjectTraffic(reportFilter: $reportFilter) {
      id 
      name
      visitorsCount
      type
    }
  }
`;

export const getTopTrafficSourcesQuery = `
  query TrafficSourcesByOwnlyEngagement(
    $reportFilter: ReportFilterArgs!
  ) {
    items: trafficSourcesByOwnlyEngagement(reportFilter: $reportFilter) {
      trafficSourceType
      websiteVisitorsCount
      ownlyVisitorsCount
      ownlyEngagementRate
    }
  }
`;

export const getPerformanceByProductQuery = `
  query PerformanceByProduct(
    $reportFilter: ReportFilterArgs!
  ) {
    results: performanceByProduct(reportFilter: $reportFilter) {
      visitors {
        ${metricTrendFragment}
      }
      savedHomes {
        ${metricTrendFragment}
      }
      startedReservations {
        ${metricTrendFragment}
      }
      completedReservations {
        ${metricTrendFragment}
      }
      verifiedIds {
        ${metricTrendFragment}
      }
      verifiedFinances {
        ${metricTrendFragment}
      }
      profileViews {
        ${metricTrendFragment}
      }
      directInvitations {
        ${metricTrendFragment}
      }
    }
  }
`;

export const getTrafficFunnelQuery = `
  query TrafficFunnel(
    $reportFilter: ReportFilterArgs!
  ) {
    results: trafficFunnel(reportFilter: $reportFilter) {
      websiteTraffic {
        ${metricTrendFragment}
      }
      ownlyVisitors {
        ${metricTrendFragment}
      }
      returningOwnlyVisitors {
        ${metricTrendFragment}
      }
      leadsGenerated {
        ${metricTrendFragment}
      }
    }
  }
`;
